import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import Footer from "components/common/Footer";
import Header from "components/ui/Header2";

const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="w-full max-w-[1182px] mx-auto px-[20px] sm:px-[30px] lg:px-[40px] py-[60px] sm:py-[80px] lg:py-[100px]">
        <div className="flex flex-col gap-[60px] sm:gap-[80px] lg:gap-[100px]">

          {/* Title Section */}
          <section>
            <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
              {t("سياسة الخصوصية")}
            </h2>
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text2 mb-[20px] sm:mb-[30px]">
              نحن نحرص على حماية بياناتك الشخصية، ونلتزم بعدم مشاركتها مع أي طرف
              ثالث بدون موافقتك. يتم استخدام البيانات لتحسين تجربتك وضمان جودة
              خدماتنا.
            </p>
          </section>

          {/* Call to Action */}
          <section className="bg-global-text4 rounded-[20px] p-[30px] sm:p-[40px] lg:p-[50px] text-center">
            <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
              هل لديك أي استفسار؟
            </h2>
            <Button
              variant="primary"
              className="bg-global-text8 text-global-text4 rounded-[8px] px-[20px] sm:px-[30px] lg:px-[40px] py-[10px] sm:py-[15px] lg:py-[20px] text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-bold"
            >
              تواصل معنا
            </Button>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;